export default __webpack_public_path__ + "media/images/casatb/tenant/banner-one-74c83f77344c8539f616034fcfe24828.png";